import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6cbce2d6&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=6cbce2d6&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=6cbce2d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbce2d6",
  null
  
)

export default component.exports